import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { ReactComponent as THMIcon } from '../assets/images/Tryhackme--Streamline-Simple-Icons.svg';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/leandrocosta-git" target="_blank" rel="noreferrer"><GitHubIcon /></a>
        <a href="https://www.linkedin.com/in/leandro-rcosta" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
        <a href="https://tryhackme.com/p/lrc" target="_blank" rel="noreferrer">
          <THMIcon className="thm-icon" />
        </a> 
      </div>
      <p>A portfolio designed & built by <a href="https://github.com/leandrocosta-git" target="_blank" rel="noreferrer">Leandro Costa</a> with 💚</p>
    </footer>
  );
}

export default Footer;